import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import AuthenticatedImage from "@/components/AuthenticatedImage";
import { X } from "@phosphor-icons/react";

export default function ImageViewer({ open, onOpenChange, path, label }) {
  if (!path) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="rounded-none border-none p-0 bg-black/95 max-w-[96vw] w-[96vw] h-[92vh] sm:max-w-[96vw]"
        data-testid="image-viewer-dialog"
      >
        <DialogTitle className="sr-only">{label || "Documento"}</DialogTitle>
        <div className="relative w-full h-full flex flex-col">
          <div className="flex items-center justify-between px-5 py-3 text-white">
            <div>
              <div className="label-eyebrow text-white/60">·Vista ampliada</div>
              <div className="font-display font-bold text-lg">{label}</div>
            </div>
            <button
              onClick={() => onOpenChange(false)}
              className="p-2 hover:bg-white/10"
              data-testid="image-viewer-close"
            >
              <X size={18} weight="bold" />
            </button>
          </div>
          <div className="flex-1 min-h-0 flex items-center justify-center px-5 pb-5">
            <AuthenticatedImage
              path={path}
              alt={label}
              className="max-w-full max-h-full object-contain"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
